import styled from 'styled-components';

interface CardInterface {
  justifyContent?: string;
  selected?: boolean
}

interface TimesGroupInterface {
  justifyContent?: string;
  selected?: boolean
}

interface GroupInterface {
  link?: boolean;
}

export const Card = styled.div<CardInterface>`
  background: ${({ theme }) => theme.colors.background};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  padding: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => (justifyContent === 'flex-start' ? 'flex-start' : 'space-between')};
  width: 100%;

  & + & {
    margin-top: 16px;
  }

  .editStatus {
    position: relative;
    left: 25%;
    transform: translateX(-50%);

    @media(max-width: 1340px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    input {
      color: ${({ theme, selected }) => (selected ? theme.colors.lighterBackground : theme.colors.primary.main)};
      background: ${({ theme, selected }) => (selected ? theme.colors.primary.main : theme.colors.background)};
      text-decoration: none;
      font-weight: bold;
      border: 2px solid ${({ theme }) => theme.colors.primary.main};
      padding: 4px 8px;
      border-radius: 4px;
      transition: all 0.2s ease-in;
      font-size: 14px;
      height: 36px;
      margin: 12px;

      @media(max-width: 500px) {
        font-size: 12px;
        height: 40px;
        padding: 2px 4px;
  }

    &:focus {
      border-color: ${({ theme }) => theme.colors.primary.main};
      color: ${({ theme }) => theme.colors.gray[900]};
   }
  }

    @media(max-width: 700px){
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    button {
      margin: 12px;
    }

  }


  }

  .info {
    .card-title {
      display: flex;
      align-items: center;

      strong {
        white-space: nowrap;
      }

      small {
        white-space: nowrap;
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        margin-left: 8px;
        font-size: 10px;
      }

      small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
      }

      small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
        }

      small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
      }
    }

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.gray[201]};

      strong {
        margin-right: 5px;
      }

      img {
        margin-left: 5px;
        width: 15px;
      }

      div {
        margin-top: 4px;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;

    img {
      &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
    }

    a {
      background: transparent;
      border: none;
      width: 23px;
      height: 23px;
      margin-right: 8px;
      cursor: pointer;
      }

    a.qrCodeLink {
      padding: 0;
      width: 24px;
      margin-top: 1px;

      img {
        width: 100% !important;
      }
    }

    button {
      border: none;
      background: transparent;
      margin-right: 8px;


      img {
        padding: 0;
        width: 24px;
        margin-top: 2px
      }
    }
  }
`;

export const TimesContainer = styled.div`
  max-height: 500px;
  overflow: auto;
`;

export const TimesGroup = styled.div<TimesGroupInterface>`
  background: ${({ theme }) => theme.colors.lighterBackground};;
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  padding: 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => (justifyContent === 'flex-start' ? 'flex-start' : 'space-between')};
  width: 100%;

  & + & {
    margin-top: 16px;
  }

  .editStatus {
    position: relative;
    left: 25%;
    transform: translateX(-50%);

    @media(max-width: 1340px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    input {
      color: ${({ theme, selected }) => (selected ? theme.colors.lighterBackground : theme.colors.primary.main)};
      background: ${({ theme, selected }) => (selected ? theme.colors.primary.main : theme.colors.background)};
      text-decoration: none;
      font-weight: bold;
      border: 2px solid ${({ theme }) => theme.colors.primary.main};
      padding: 4px 8px;
      border-radius: 4px;
      transition: all 0.2s ease-in;
      font-size: 14px;
      height: 36px;
      margin: 12px;

      @media(max-width: 500px) {
        font-size: 12px;
        height: 40px;
        padding: 2px 4px;
  }

    &:focus {
      border-color: ${({ theme }) => theme.colors.primary.main};
      color: ${({ theme }) => theme.colors.gray[900]};
   }
  }

    @media(max-width: 700px){
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    button {
      margin: 12px;
    }

  }


  }

  .info {
    .card-title {
      display: flex;
      align-items: center;

      small {
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        margin-left: 8px;
        font-size: 10px;
      }

      small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
      }

      small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
        }

      small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
      }
    }

    span {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.gray[201]};

      strong {
        margin-right: 5px;
      }

      img {
        margin-left: 5px;
        width: 15px;
      }

      div {
        margin-top: 4px;
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;

    img {
      &:hover{
        opacity: 0.5;
        transition: ease-in 0.2s;
      }
      &:not(:hover) {
        opacity: 1;
        transition: ease-in 0.2s;
      }
    }

    a {
      background: transparent;
      border: none;
      width: 23px;
      height: 23px;
      margin-right: 8px;
      cursor: pointer;
      }

    a.qrCodeLink {
      padding: 0;
      width: 24px;
      margin-top: 1px;

      img {
        width: 100% !important;
      }
    }

    button {
      border: none;
      background: transparent;
      margin-right: 8px;


      img {
        padding: 0;
        width: 24px;
        margin-top: 2px
      }
    }
  }
`;

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.lighterBackground};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  padding: 16px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  div.card-title {
    font-weight: bold;
    font-size: 24px;
    margin-top: -8px;
    margin-left: -4px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      font-weight: bold;
      font-size: 24px;
    }

    div.actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }

    img {
      width: 24px;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      filter: ${({ theme }) => theme.filters.primary};
      &:hover {
        opacity: 0.7
      }
    }
  }
`;

export const Group = styled.div<GroupInterface>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  margin: 4px 0px;
  margin-right: 16px;

  div.title {
    margin: 4px 0px;
    font-size: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      font-size: 16px;
    }
    img {
      &:hover {
        opacity: 0.6
      }
      cursor: pointer;
      filter: ${({ theme }) => theme.filters.primary};
      width: 21px;
      transition: all 0.2s ease-in-out;
    }
  }

  span {
    max-height: 66px;
    overflow: auto;
    margin-bottom: 2px;
    word-break: ${({ link }) => (link ? 'break-all' : 'keep-all')};
  }
`;

export const AsideContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;

  @media(max-width: 500px) {
    flex-direction: column;
  }
`;

export const CarouselContainer = styled.div`
  background: ${({ theme }) => theme.colors.lighterBackground};
  box-shadow: 8px 4px 10px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding-top: 16px;

  .carousel {
    padding: 8px 16px 16px 16px;
    border-radius: 4px;
    .carousel-item {
      border-radius: 4px;
      img {
        border-radius: 4px;
        /* mask-image: linear-gradient(90deg, transparent 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, transparent 95%); */
      }
    }
  }

  div.card-title {
    font-weight: bold;
    font-size: 24px;
    margin-top: -12px;
    margin-left: 12px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    img {
      width: 24px;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      filter: ${({ theme }) => theme.filters.primary};
      &:hover {
        opacity: 0.7
      }
    }
  }
`;
